import { NavLink, useParams } from 'react-router-dom';
import { isInArray } from '../../utils/function';
import { useAuth } from '../../hooks/AuthProvider';

function CompanySidebar(props) {
  const { id } = useParams();
  const auth = useAuth();

  return (
    <div className="flex flex-nowrap overflow-x-scroll no-scrollbar md:block md:overflow-auto px-3 py-6 border-b md:border-b-0 md:border-r border-slate-200 dark:border-slate-700 min-w-[15rem] md:space-y-3">
      {/* Group 1 */}
      <div>
        <ul className="flex flex-nowrap md:block mr-3 md:mr-0">
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            <NavLink
              end
              to={`/company/${id}/offers`}
              className={({ isActive }) => 
                `flex items-center px-2.5 py-2 rounded whitespace-nowrap ${
                  isActive ? 'bg-royalblue-50 dark:bg-royalblue-500/30' : ''
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <svg 
                    className={`w-6 h-6 shrink-0 fill-current mr-2 ${
                      isActive ? 'text-royalblue-500 dark:text-royalblue-400' : 'text-slate-400 dark:text-slate-500'
                    }`} 
                    width="16" height="16" viewBox="0 0 24 24"
                  >
                    <path fill="currentColor" d="m21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4S7 4.67 7 5.5S6.33 7 5.5 7z"/>
                  </svg>
                  <span className={`text-sm font-medium ${
                    isActive ? 'text-royalblue-500 dark:text-royalblue-400' : 'text-slate-600 dark:text-slate-300 hover:text-slate-700 dark:hover:text-slate-200'
                  }`}>
                    Mes offres
                  </span>
                </>
              )}
            </NavLink>
          </li>

          {isInArray(props.admins, auth.user.user._id, 'admin') && (
            <>
              <li className="mr-0.5 md:mr-0 md:mb-0.5">
                <NavLink
                  end
                  to={`/company/${id}/settings`}
                  className={({ isActive }) => 
                    `flex items-center px-2.5 py-2 rounded whitespace-nowrap ${
                      isActive ? 'bg-royalblue-50 dark:bg-royalblue-500/30' : ''
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <svg 
                        className={`w-6 h-6 shrink-0 fill-current mr-2 ${
                          isActive ? 'text-royalblue-500 dark:text-royalblue-400' : 'text-slate-400 dark:text-slate-500'
                        }`} 
                        width="40" height="40" viewBox="0 0 256 256"
                      >
                        <g id="galaSettings0" fill="none" stroke="currentColor" strokeDasharray="none" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="4" strokeOpacity="1" strokeWidth="16">
                          <path id="galaSettings1" d="M 48.000002,16 H 208 c 17.728,0 32,14.272 32,32 v 160 c 0,17.728 -14.272,32 -32,32 H 48.000002 c -17.728,0 -32,-14.272 -32,-32 V 48 c 0,-17.728 14.272,-32 32,-32 z"/>
                          <path id="galaSettings2" d="M 64.000006,64.000001 H 79.999993"/>
                          <path id="galaSettings3" d="m 79.999996,-96.000015 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16.000005 16,16 0 0 1 16,16.000005 z" transform="rotate(90)"/>
                          <path id="galaSettings4" d="m 112.00001,64.000353 79.99997,-3.52e-4"/>
                          <path id="galaSettings5" d="M 191.99998,128 H 176"/>
                          <path id="galaSettings6" d="m 144,159.99997 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16 16,16 0 0 1 16,16 z" transform="matrix(0 1 1 0 0 0)"/>
                          <path id="galaSettings7" d="M 143.99998,128.00035 64.000006,128"/>
                          <path id="galaSettings8" d="M 64.000006,192.00001 H 79.999993"/>
                          <path id="galaSettings9" d="m 208,-96.000015 a 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 16,-16.000005 16,16 0 0 1 16,16.000005 z" transform="rotate(90)"/>
                          <path id="galaSettingsa" d="m 112.00001,192.00036 79.99997,-3.5e-4"/>
                        </g>
                      </svg>
                      <span className={`text-sm font-medium ${
                        isActive ? 'text-royalblue-500 dark:text-royalblue-400' : 'text-slate-600 dark:text-slate-300 hover:text-slate-700 dark:hover:text-slate-200'
                      }`}>
                        {props.typeCompany === 'multi' ? "Gestion compte" : "Gestion page"}
                      </span>
                    </>
                  )}
                </NavLink>
              </li>

              {props.typePage === "company" && (
                <>
                  <li className="mr-0.5 md:mr-0 md:mb-0.5">
                    <NavLink
                      end
                      to={`/company/${id}/settings-sub`}
                      className={({ isActive }) => 
                        `flex items-center px-2.5 py-2 rounded whitespace-nowrap ${
                          isActive ? 'bg-royalblue-50 dark:bg-royalblue-500/30' : ''
                        }`
                      }
                    >
                      {({ isActive }) => (
                        <>
                          <svg 
                            className={`w-6 h-6 shrink-0 fill-current mr-2 ${
                              isActive ? 'text-royalblue-500 dark:text-royalblue-400' : 'text-slate-400 dark:text-slate-500'
                            }`} 
                            width="200" height="200" viewBox="0 0 56 56"
                          >
                            <path fill="currentColor" d="M46.847 8.448A6 6 0 0 1 47.052 10l-.001 6.001l.174.004A6 6 0 0 1 53 22v24a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6V22l.003-.205l.01-.18a6.002 6.002 0 0 1 4.436-6.167l32.05-11.243a6 6 0 0 1 7.348 4.243M47 20H9a2 2 0 0 0-1.995 1.851l-.005.15v24a2 2 0 0 0 1.85 1.994L9 48h38a2 2 0 0 0 1.995-1.85L49 46V22a2 2 0 0 0-1.85-1.994zM37 30a4 4 0 1 1 0 8a4 4 0 0 1 0-8m3.68-21.965l-.048.011L17.957 16h25.094v-6a2 2 0 0 0-.03-.347l-.038-.17a2 2 0 0 0-2.304-1.448"/>
                          </svg>
                          <span className={`text-sm font-medium ${
                            isActive ? 'text-royalblue-500 dark:text-royalblue-400' : 'text-slate-600 dark:text-slate-300 hover:text-slate-700 dark:hover:text-slate-200'
                          }`}>
                            Gestion abonnement
                          </span>
                        </>
                      )}
                    </NavLink>
                  </li>

                  <li className="mr-0.5 md:mr-0 md:mb-0.5">
                    <NavLink
                      end
                      to={`/company/${id}/dashboard-sub`}
                      className={({ isActive }) => 
                        `flex items-center px-2.5 py-2 rounded whitespace-nowrap ${
                          isActive ? 'bg-royalblue-50 dark:bg-royalblue-500/30' : ''
                        }`
                      }
                    >
                      {({ isActive }) => (
                        <>
                          <svg 
                            className={`w-6 h-6 shrink-0 fill-current mr-2 ${
                              isActive ? 'text-royalblue-500 dark:text-royalblue-400' : 'text-slate-400 dark:text-slate-500'
                            }`} 
                            width="200" height="200" viewBox="0 0 56 56"
                          >
                            <path fill="currentColor" d="M46.847 8.448A6 6 0 0 1 47.052 10l-.001 6.001l.174.004A6 6 0 0 1 53 22v24a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6V22l.003-.205l.01-.18a6.002 6.002 0 0 1 4.436-6.167l32.05-11.243a6 6 0 0 1 7.348 4.243M47 20H9a2 2 0 0 0-1.995 1.851l-.005.15v24a2 2 0 0 0 1.85 1.994L9 48h38a2 2 0 0 0 1.995-1.85L49 46V22a2 2 0 0 0-1.85-1.994zM37 30a4 4 0 1 1 0 8a4 4 0 0 1 0-8m3.68-21.965l-.048.011L17.957 16h25.094v-6a2 2 0 0 0-.03-.347l-.038-.17a2 2 0 0 0-2.304-1.448"/>
                          </svg>
                          <span className={`text-sm font-medium ${
                            isActive ? 'text-royalblue-500 dark:text-royalblue-400' : 'text-slate-600 dark:text-slate-300 hover:text-slate-700 dark:hover:text-slate-200'
                          }`}>
                            Dashboard
                          </span>
                        </>
                      )}
                    </NavLink>
                  </li>
                </>
              )}
            </>
          )}
        </ul>
      </div>
    </div>
  );
}

export default CompanySidebar;